import { render, staticRenderFns } from "./StatoMercatoSelect.vue?vue&type=template&id=394e85d0&scoped=true&"
import script from "./StatoMercatoSelect.vue?vue&type=script&lang=js&"
export * from "./StatoMercatoSelect.vue?vue&type=script&lang=js&"
import style0 from "./StatoMercatoSelect.vue?vue&type=style&index=0&id=394e85d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e85d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('394e85d0')) {
      api.createRecord('394e85d0', component.options)
    } else {
      api.reload('394e85d0', component.options)
    }
    module.hot.accept("./StatoMercatoSelect.vue?vue&type=template&id=394e85d0&scoped=true&", function () {
      api.rerender('394e85d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/StatoMercatoSelect.vue"
export default component.exports